module.exports = __webpack_public_path__ + "img/icon-sb-ottoman-recliner-48x48.8af3db9.svg";